module.exports = __webpack_public_path__ + "media/svg/logoarmen-0ca28c20.svg";